import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Alert } from '@/components/ui/alert';
import { Spinner } from '@/components/ui/spinner';
import type { CurrentUser } from '@/api/auth';
import { useAuth } from './useAuth';

export interface ProtectedRouteProps {
  roles: CurrentUser['role'][];
  children: ReactNode;
}

export const ProtectedRoute = ({ roles, children }: ProtectedRouteProps) => {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <Spinner label="Bejelentkezés ellenőrzése…" />;
  }

  if (status === 'anonymous' || !user) {
    return <Navigate to="/admin/belepes" state={{ from: location.pathname }} replace />;
  }

  if (!roles.includes(user.role)) {
    if (user.role === 'DRIVER' && !location.pathname.startsWith('/sofor')) return <Navigate to="/sofor" replace />;
    if (user.role === 'ADMIN' && location.pathname.startsWith('/sofor')) return <Navigate to="/admin" replace />;
    return (
      <div className="mx-auto max-w-2xl p-6">
        <Alert tone="danger" title="Ehhez az oldalhoz nincs jogosultsága">
          Ha úgy gondolja, hogy hozzáférésre van szüksége, kérjük, keresse az adminisztrátort.
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
};
